import React, { createContext, useState } from 'react';
import { OfferStatusId } from 'sharedTypes/offers/offers';

export const OfferStatusContext = createContext(null);
OfferStatusContext.displayName = 'OfferStatusContext';

export const OfferStatusProvider = ({ children }: { children: React.ReactNode }) => {
  const [offerStatus, setOfferStatus] = useState<OfferStatusId>(null);

  return (
    <OfferStatusContext.Provider value={[offerStatus, setOfferStatus]}>
      {children}
    </OfferStatusContext.Provider>
  )
};
